import React from 'react';
import PropTypes from 'prop-types';
import {InlineBlocks} from 'react-tinacms-inline';
import PageBlock from './PageBlock';
import {pageBlockFields} from '../../constants/fields/fields';
import {horizontalBlock} from '../../constants/templates/horizontalBlock';
import {ImageForColumn} from '../Image/Image';
import {SimpleBlock} from './SimpleInnerBlock';
import {usePage} from '../../contexts/PageContext';
import {HorizContainer} from '../Common/HorizContainer';

const BLOCKS = {
  simple: SimpleBlock,
  image: ImageForColumn,
};

// eslint-disable-next-line react/display-name
const HorizontalComponent = ({data, ...props}) => {
  const {viewport} = usePage();
  return (
    <PageBlock {...props} data={data}>
      <HorizContainer viewport={viewport} blocks={data.content?.blocks}>
        <InlineBlocks name={'blocks'}
          direction={'horizontal'}
          className={'dfl-cms-horizontal-container'}
          itemProps={data?.itemProps}
          blocks={BLOCKS}
        />
      </HorizContainer>
    </PageBlock>
  );
};

export const HorizontalBlock = {
  Component: HorizontalComponent,
  template: {
    _template: 'horizontal',
    label: 'Horizontal Block',
    defaultItem: horizontalBlock,
    fields: pageBlockFields
  },
};

HorizontalComponent.propTypes = {
  data: PropTypes.object
};
